var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0031 2.5H5.01563C3.64063 2.5 2.51562 3.625 2.51562 5V27.5L7.50313 22.5H25.0031C26.3781 22.5 27.5031 21.375 27.5031 20V5C27.5031 3.625 26.3781 2.5 25.0031 2.5ZM16.2531 17.5H13.7531V15H16.2531V17.5ZM16.2531 11.25C16.2531 11.9375 15.6906 12.5 15.0031 12.5C14.3156 12.5 13.7531 11.9375 13.7531 11.25V8.75C13.7531 8.0625 14.3156 7.5 15.0031 7.5C15.6906 7.5 16.2531 8.0625 16.2531 8.75V11.25Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.5d1f168cfbce9e22af73401e46ed9485.svg";
export { ForwardRef as ReactComponent };